function uniqueOptions(rows, getValue, getLabel) {
    const seen = new Map();
    rows.forEach((row) => {
        const value = getValue(row);
        if (!seen.has(value))
            seen.set(value, getLabel(row));
    });
    return Array.from(seen.entries())
        .map(([value, label]) => ({ value, label }))
        .sort((a, b) => a.label.localeCompare(b.label));
}
/** Category options come only from what's present — there is no "all categories" endpoint in scope here. */
export function buildCategoryOptions(rows) {
    return uniqueOptions(rows, (row) => row.categoryFilterValue, (row) => row.categoryLabel);
}
/** E2E-24: File type options are derived from the types actually present, not a fixed list. */
export function buildFileTypeOptions(rows) {
    return uniqueOptions(rows, (row) => row.typeFilterValue, (row) => row.typeLabel);
}
/**
 * Category options for the inline-edit `Category` cell (`InlineSelect`), plus the `null` "No
 * category" sentinel the legacy form always includes (`include_blank`, `new.html.erb:32`).
 *
 * Task-14's facade (task-19, out of this task's scope) is the intended long-term source — the
 * legacy view pulls the full tenant category list via `AttachmentCategory.pluck(:name, :id)`,
 * not just categories currently in use. Until that facade prop is threaded through, this derives
 * the same shape from what's already fetched (the categories actually present on this building's
 * rows) as a sensible default — `AttachmentsTable`'s `categoryOptions` prop lets a caller override
 * it with the real tenant-wide list once task-19 lands.
 */
export function buildCategoryEditOptions(rows, translateFn) {
    const seen = new Map();
    rows.forEach((row) => {
        if (row.categoryId != null && !seen.has(row.categoryId))
            seen.set(row.categoryId, row.categoryLabel);
    });
    const categories = Array.from(seen.entries())
        .map(([id, label]) => ({ id, label }))
        .sort((a, b) => a.label.localeCompare(b.label));
    return [{ id: null, label: translateFn('no_category') }, ...categories];
}
/** Visibility options are fixed (not data-derived) — see the design's three-option enumeration. */
export function buildVisibilityOptions(translateFn) {
    return [
        { value: 'techs', label: translateFn('visibility_options.techs') },
        { value: 'hidden', label: translateFn('visibility_options.hidden') },
        { value: 'portal', label: translateFn('visibility_options.portal') }
    ];
}
